export enum CHAT_TYPE{
  REACTIVE = 1,
  PROACTIVE,
  EXTERNAL
}
